import { render } from "./CompanyServices.vue?vue&type=template&id=35671add&scoped=true&ts=true"
import script from "./CompanyServices.vue?vue&type=script&lang=ts"
export * from "./CompanyServices.vue?vue&type=script&lang=ts"

import "./CompanyServices.vue?vue&type=style&index=0&id=35671add&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35671add"]])

export default __exports__